import React from 'react';
import { Table } from 'reactstrap';
import CommentRow from './CommentRow';
import EmptyTableMessage from '../../../../../shared/components/EmptyTableMessage';
import { FlowComment } from '../../../../../services/types/Flow';

interface Props {
  commentListData: FlowComment[];
  flowType: string;
  hideExpander?: boolean;
}

const CommentsTable: React.FC<Props> = (props) => {
  const { commentListData, flowType, hideExpander } = props;

  const renderRows = (list: FlowComment[]) =>
    list.map((x) => (
      <CommentRow
        key={`${x.author}_${x.date}_${x.topic}_${x.version}_${x.lap}`}
        data={x}
        flowType={flowType}
        hideExpander={hideExpander}
      />
    ));

  return (
    <>
      <div className="table-wrapper">
        <Table responsive className="flow-comments-table">
          <tbody>{renderRows(commentListData)}</tbody>
        </Table>
      </div>
      {commentListData.length === 0 && <EmptyTableMessage />}
    </>
  );
};

export default CommentsTable;
